import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=10d96d50&scoped=true"
import script from "./Appeal.vue?vue&type=script&lang=js"
export * from "./Appeal.vue?vue&type=script&lang=js"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=10d96d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d96d50",
  null
  
)

export default component.exports